<template>
    <div class="product-review-success-modal">
        <div class="product-review-success">
            <span class="product-review-success-modal__check">
                <svg><use xlink:href="#svg-check-vertical"></use></svg>
            </span>
            <div class="product-review-success__block" v-html="messages.successReview"></div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ProductReviewSuccessModal",
        selector: ".product-review-success-modal",
        props: ['messages'],

        methods: {
            closeModal: function () {
                this.$emit('close');
            }
        },
    }
</script>

<style lang="scss" scoped>
    .product-review-success-modal {
        h2 {
            padding: 30px 0 0 50px;
            margin-bottom: 20px;
        }

        &__close {
            cursor: pointer;
            position: absolute;
            top: 8px;
            right: 8px;
            z-index: 1;

            svg {
                fill: #85898B;
                width: 20px;
                height: 20px;
            }
        }
        &__check {
            svg {
                /*fill: #85898B;*/
                fill: #4b4d4e;
                width: 30px;
                height: 30px;
            }
        }
    }

    .product-review-success {
        display: flex;
        justify-content: space-between;
        width: 100%;
        gap: 10px;
        padding: 30px 30px 30px 30px;
        font-size: rem(12);

        &__block {
            width: 100%;
        }

        @include point-lg {
            flex-direction: row;
            /*gap: 80px;*/
        }
    }
</style>